const SvgComponent = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="5.7002" width="18" height="12.6" rx="2" stroke="#111" strokeWidth="2"/>
  </svg>
)
export default SvgComponent
